export interface IShopifySectionLink {
    url: string;
    title: string;
}

export interface IShopifyFooterSection {
    title: string;
    links: IShopifySectionLink[]
}

export const houseLinks: IShopifySectionLink[] = [
    {
        url: '/products/la-dream-house',
        title: 'Los Angeles Dream House',
    },
    {
        url: '/products/miami-dream-house',
        title: 'Miami Dream House',
    },
];

export function getPrizesLinks (): IShopifySectionLink[] {
    return [
        {
            url: '/collections/omaze-cars',
            title: 'Cars',
        },
        {
            url: '/collections/celebrity',
            title: 'Celebrity',
        },
        {
            url: '/collections/cash-prizes',
            title: 'Financial Freedom',
        },
        {
            url: '/collections/houses',
            title: 'Houses',
        },
        {
            url: '/collections/travel',
            title: 'Travel',
        },
        {
            url: '/collections/experiences',
            title: 'See All Prizes',
        },
    ];
}

export const shopifyFooterSections: IShopifyFooterSection[] = [
    {
        title: 'PRIZES',
        links: getPrizesLinks(),
    },
    {
        title: 'ABOUT',
        links: [
            {
                url: '/pages/about-us',
                title: 'About Us',
            },
            {
                url: '/collections/winners',
                title: 'Winners',
            },
            {
                url: 'https://impact.omaze.com',
                title: 'Impact',
            },
            {
                url: 'https://boards.greenhouse.io/omaze',
                title: 'Careers',
            },
        ],
    },
    {
        title: 'SUPPORT',
        links: [
            {
                url: '/pages/rules',
                title: 'Official Rules',
            },
            {
                url: '/pages/privacy',
                title: 'Privacy Policy',
            },
            {
                url: '/pages/terms',
                title: 'Terms of Use',
            },
            {
                url: '/pages/disclosures',
                title: 'State Disclosures',
            },
            {
                url: 'https://support.omaze.com/hc/en-us',
                title: 'Help Center',
            },
            {
                url: '/pages/do-not-sell-my-personal-information',
                title: 'Do Not Sell My Personal Information',
            },
        ],
    },
];
